import SaveButton from "components/Buttons/SaveButton";
import SCRIPT_STATUS from "enums/SCRIPT_STATUS";
import useCreateOrUpdateScript from "hooks/api/useCreateOrUpdateScript";
import useFormHelpers from "../FormScript/hooks/useFormHelpers";
import useScriptManagementStore from "../hooks/useScriptManagementStore";
import { DEFAULT_FORM_STATE } from "../store";

export default function BtnSaveDraft() {
  const { createOrUpdateScript, createNotificationFromResponse, isWriting } =
    useCreateOrUpdateScript();
  const {
    handleStoreChange,
    setHasScriptChange,
    hasScriptChange,
    hasScriptError,
  } = useScriptManagementStore();
  const { payload, isModerated } = useFormHelpers();

  async function onSaveDraft() {
    // reset questions and status for MODERATED scripts
    const _payload = { ...payload };
    if (isModerated()) {
      _payload.status = SCRIPT_STATUS.PUBLISHED;
      _payload.questions = DEFAULT_FORM_STATE.script.questions || [];
    }
    const response = await createOrUpdateScript(_payload);

    setHasScriptChange(false);
    handleStoreChange("script", response.data);
    createNotificationFromResponse(response);
  }

  return (
    <SaveButton
      onClick={onSaveDraft}
      disabled={
        !payload.title ||
        !payload.description ||
        !hasScriptChange ||
        hasScriptError ||
        isWriting
      }
    >
      {isModerated() ? "SAVE" : "SAVE DRAFT"}
    </SaveButton>
  );
}
